import { createFileRoute, notFound } from "@tanstack/react-router";
import { gatedRobotsMeta } from "@/lib/seo-gating";
import { TopicResourceView } from "@/components/learn/topic/TopicResourceView";

export const Route = createFileRoute("/learn/$topic/$section/$resource")({
  // Topic content is fetched when a Learn page opens, not on every visit.
  loader: async ({ params }) => {
    const [{ getTopic }, { findResource, findSection }] = await Promise.all([
      import("@/data/learn/topics"),
      import("@/data/learn/topic-types"),
    ]);
    const topic = getTopic(params.topic);
    const section = topic ? findSection(topic, params.section) : null;
    const resource = topic ? findResource(topic, params.section, params.resource) : null;
    if (!topic || !section || !resource) throw notFound();
    return { topic, section, resource };
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Not found — Recovery Trauma™" }, { name: "robots", content: "noindex" }] };
    }
    const { topic, section, resource } = loaderData;
    const title = `${resource.title} — ${topic.title} — Recovery Trauma™`;
    const url = `https://recoverytrauma.com/learn/${topic.slug}/${section.slug}/${resource.slug}`;
    return {
      meta: [
        { title },
        { name: "description", content: resource.summary },
        { property: "og:title", content: title },
        { property: "og:description", content: resource.summary },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        ...gatedRobotsMeta(`/learn/${topic.slug}/${section.slug}/${resource.slug}`),
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: ResourcePage,
});

function ResourcePage() {
  const { topic, section, resource } = Route.useLoaderData();
  return <TopicResourceView topic={topic} section={section} resource={resource} />;
}
